/* 🤖 this file was generated by svg-to-ts */
export const nsCopy: {
  name: 'copy';
  data: string;
} = {
  name: 'copy',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M3.636 2h11.455c.9 0 1.636.736 1.636 1.636v1.637h1.637c.9 0 1.636.736 1.636 1.636v11.455c0 .9-.736 1.636-1.636 1.636H6.909c-.9 0-1.636-.736-1.636-1.636v-1.637H3.636c-.9 0-1.636-.736-1.636-1.636V3.636C2 2.736 2.736 2 3.636 2Zm1.637 13.09V6.91c0-.9.736-1.637 1.636-1.637h8.182V3.636H3.636v11.455h1.637Zm13.09-8.18v11.454H6.91V6.909h11.455Z" clip-rule="evenodd"/></svg>`
};
